import axios from 'axios'
import { logAxiosSuccess, logAxiosError } from '@/util/log'
import { showLoginBox, token } from '@/provider/global'
import { ElMessage } from 'element-plus'

// 暂时解决重复提示问题
const messages = {}
const showErrorMessage = ElMessage.error
ElMessage.error = function(message) {
  let instance = messages[message]
  if(!instance) {
    instance = showErrorMessage({ message, duration: 0 })
    messages[message] = instance
  }
  instance.timer && clearInterval(instance.timer)
  instance.timer = setTimeout(() => {
    instance.close()
    delete messages[message]
  }, 3000)
}

let config = {
  baseURL: process.env.VUE_APP_apiBaseUrl || '',
  timeout: 60 * 1000,
  withCredentials: false
}

let instance = axios.create(config)

instance.interceptors.request.use(
  config => {
    if (token.value) config.headers['x-agency-token'] = token.value
    config.headers['tenant-id'] = process.env.VUE_APP_defaultTenantId
    config.headers['Bm-Area-Id'] = config.headers['Bm-Area-Id'] || -1
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

instance.interceptors.response.use(
  response => {
    const newToken = response.headers['x-refresh-token']
    if (newToken) token.value = newToken
    if (
      response.data.code === 0 ||
      response.data.code === 200 ||
      response.data.err === 0 ||
      typeof response.data.code === 'undefined'
    ) {
      logAxiosSuccess(response)
      if (response.data.list) {
        let page = response.data.page
        if (page) {
          page.isFinish = page.page * page.size >= page.total
        }
        return { page, list: response.data.list, other: response.data.other }
      }
      return response.data.data || response.data
    } else {
      logAxiosError(response)
      if([2001, 2002, 2003].includes(response.data.code)) {
        // const { pathname, search } = window.location
        // window.location.href = `/account/login?callback=${encodeURIComponent(pathname + search)}`
        showLoginBox.value = true
        token.value = ''
        // showMessage('登录过期，请重新登录')
      } else {
        ElMessage.error(response.data.msg)
      }
      return Promise.reject(response.data)
    }
  },
  error => {
    ElMessage.error(error.message)
    return Promise.reject(error)
  }
)

export default instance

//相同请求优化处理
const taskMap = new Map()
export function addTask(key, task) {
  if (taskMap.get(key)) return taskMap.get(key)
  const t = task()
  taskMap.set(key, t)
  return t.finally(() => {
    setTimeout(() => {
      taskMap.delete(key)
    }, 50)
  })
}
